import {useTranslation} from "react-i18next";
import ModalWindow from "../modal";
import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../App";
import DB_User from "../../database/admin/user";
import {Outlet, useNavigate} from "react-router-dom";
import {Button, Col, Form, Input, notification, PageHeader, Row, Spin} from "antd";
import md5 from "md5";
import Avatar from "antd/es/avatar/avatar";
import {EyeInvisibleOutlined, EyeTwoTone} from "@ant-design/icons";

export const UserSettings = () => {
    const {t} = useTranslation();
    const {errorConnect} = ModalWindow();
    const {token, user} = useContext(Context);
    const {getUser, checkEmail, updateUserSelf} = DB_User(token);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [wait, setWait] = useState(true);
    const [passwordRequired, setPasswordRequired] = useState(true)
    // const [avatar, setAvatar] = useState()
    const [avatarFile, setAvatarFile] = useState()
    const [userInitials, setUserInitials] = useState()


    const openNotificationFalse = (action) => {
        notification.error({
            message: 'Failed',
            description:
                t('e_update_create', {action: action, type: t('user').toLowerCase()}),
            placement: 'top'
        });
    };

    // const getBase64 = (img, callback) => {
    //     const reader = new FileReader();
    //     reader.addEventListener('load', () => callback(reader.result));
    //     reader.readAsDataURL(img);
    // };
    //
    // const handleChange = (info) => {
    //     setAvatarFile(info.file.originFileObj)
    //     if (info.file.status === 'done') {
    //         getBase64(info.file.originFileObj, url => {
    //             setAvatar(url);
    //         });
    //     }
    // };


    const setAutoPass = () => {
        const pass = autoPass()

        form.setFieldsValue({
            password: pass,
            confirmPassword: pass
        });
    }

    const autoPass = () => {
        let result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (let i = 0; i < 8; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }

    const onFinish = async (values) => {
        setWait(true);

        const formData = new FormData;
        formData.append('email', values['email'])
        formData.append('user_id', user.id)


        if (await checkEmail(formData)) {
            const formData = new FormData();

            formData.append('id', user.id)
            formData.append('name', values['name'])
            formData.append('email', values['email'])
            if (values['password'] != null) {
                formData.append('password', md5(values['password']))
            }
            // if (avatarFile == null) {
            //     formData.append('avatar', avatar)
            // } else {
            formData.append('avatar', avatarFile)
            // }


            updateUserSelf(formData)
                .then(res => {
                    if (res.status === 200) {
                        // console.log(window.history.back())
                        window.location.reload()
                        // navigate('/', {replace: true});
                    } else {
                        openNotificationFalse(t('updating'));
                    }
                })
                .catch(e => {
                    if (e.response.status === 403) {
                        window.location.reload()
                    } else {
                        setWait(false);
                        errorConnect();
                    }
                })

        } else {
            setWait(false);
            notification.error({
                message: 'Error',
                description:
                    t('e_duplicate_email', {email: values['email']}),
                placement: 'top'
            });
        }


    };


    const requiredPassword = (e) => {
        if (e.target.value.length > 0) {
            setPasswordRequired(true)
        } else {
            setPasswordRequired(false)
        }

    }


    useEffect(() => {
        if (user.id != null) {
            setPasswordRequired(false)
            getUser(user.id)
                .then(res => {
                    res.data.map(user => {
                        // if (user['avatar'] != null) {
                        //     setAvatar(user['avatar'])
                        // }
                        const initials = user['name'].split(" ")
                            .map((l, i) => {
                                if (i < 3) {
                                    return l[0]
                                }
                            })
                        setUserInitials(initials)
                        console.log(initials)
                        form.setFieldsValue({
                            name: user['name'],
                            email: user['email'],
                            role: user['role'],
                        });
                        setWait(false);
                    })
                })
                .catch((e) => {
                    if (e.response.status === 403) {
                        window.location.reload()
                    } else {
                        setWait(false);
                        errorConnect();
                    }
                });
        } else {
            navigate("/", {replace: true});
        }
    }, [])


    return (
        <Spin spinning={wait} delay={300}>
            <div className="page">
                <PageHeader
                    className="site-page-header"
                    onBack={() => window.history.back()}
                    title={user.name}

                    extra={[
                        <Button type={"primary"} htmlType="submit" form={"form"} key='2'>{t('save')}</Button>,
                    ]}
                />

                <Row>
                    <Col flex={1}>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <Avatar
                                size={150}
                                // src={avatar}
                                style={{
                                    color: '#3c7586',
                                    backgroundColor: '#cee8e9',
                                }}>{userInitials}</Avatar>
                            {/*<br/>*/}
                            {/*<br/>*/}
                            {/*<Upload style={{display: 'contents'}}*/}
                            {/*        onChange={handleChange}*/}
                            {/*        accept="image/png,image/jpeg,image/jpg"*/}
                            {/*        showUploadList={false}*/}
                            {/*        action={url_user_avatar}*/}
                            {/*>*/}
                            {/*    <Button icon={<UploadOutlined/>}>{t('click_to_upload')}</Button>*/}
                            {/*</Upload>*/}

                        </div>
                    </Col>
                    <Col flex={7}>
                        <Form form={form}
                              labelCol={{
                                  span: 8
                              }}
                              wrapperCol={{
                                  span: 10
                              }}
                              layout={"vertical"}
                              onFinish={onFinish}
                              autoComplete="off"
                              id={"form"}
                        >
                            <Form.Item style={{marginBottom: '10pt'}}
                                       name="name"
                                       label={t('name')}
                                       rules={[
                                           {
                                               required: true,
                                               message: t('e_input', {input: t('name').toLowerCase()}),
                                           },
                                       ]}
                                       hasFeedback
                            >
                                <Input/>
                            </Form.Item>

                            <Form.Item
                                name={"email"}
                                label={t('email')}
                                tooltip={t('login')}
                                rules={[
                                    {
                                        type: 'email',
                                        message: t('e_valid_email'),
                                    },
                                    {
                                        required: true,
                                        message: t('e_input', {input: t('email').toLowerCase()}),
                                    },
                                ]}
                                hasFeedback
                                style={{marginBottom: '10pt'}}
                            >
                                <Input/>
                            </Form.Item>

                            <Form.Item
                                name={"password"}
                                label={t('password')}
                                rules={[
                                    {
                                        required: passwordRequired,
                                        message: t('e_input', {input: t('password').toLowerCase()}),
                                    },
                                    {
                                        type: "string",
                                        min: 6
                                    }

                                ]}
                                hasFeedback
                                style={{marginBottom: '10pt'}}
                            >
                                <Input.Password onChange={requiredPassword}
                                                iconRender={(visible) => (visible ? <EyeTwoTone/> :
                                                    <EyeInvisibleOutlined/>)}/>
                            </Form.Item>

                            <Form.Item
                                name={"confirmPassword"}
                                label={t('confirm_password')}
                                dependencies={['password']}
                                rules={[
                                    {
                                        required: passwordRequired,
                                        message: t('e_input', {input: t('confirm_password').toLowerCase()}),
                                    },
                                    ({getFieldValue}) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }

                                            return Promise.reject(new Error(t('e_confirm_password')));
                                        },
                                    }),
                                ]}
                                hasFeedback
                                style={{marginBottom: '10pt'}}
                            >
                                <Input.Password onChange={requiredPassword}
                                                iconRender={(visible) => (visible ? <EyeTwoTone/> :
                                                    <EyeInvisibleOutlined/>)}/>
                            </Form.Item>

                            <Form.Item style={{marginBottom: '10pt'}}>
                                <Button type={"default"} onClick={setAutoPass}>{t('auto_generate_password')}</Button>
                            </Form.Item>

                        </Form>


                    </Col>
                </Row>
            </div>
            <Outlet/>
        </Spin>
    )
}

export default UserSettings;